// 原先想用 dd api 来设置 title, 但在不同钉钉版本下有差异, 故目前使用通过 document 修改来
export function setDingtalkTitle(title: string): void {
    const titleElement = document.getElementById('backend-title');
    if (titleElement) {
        titleElement.innerHTML = title;
    }
}
